module.exports = __webpack_public_path__ + "img/27.62e4d1f9.jpg";